'use client'

import type { ReactNode } from 'react'
import { Link } from '@/i18n/navigation'
import { Footer, MarketingNav } from '@/components/marketing'
import { MartiniWordmark } from '@/components/marketing/MartiniWordmark'
import { MarketingTracker } from '@/components/marketing/MarketingTracker'
import { LocaleAccessGate } from '@/components/i18n/LocaleAccessGate'
import { Providers } from '../../providers'

export default function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <Providers>
      <LocaleAccessGate>
        <div className="flex min-h-screen scroll-smooth flex-col bg-black text-white">
          {/* Mobile Navbar Background */}
          <div className="pointer-events-none fixed start-0 end-0 top-0 z-40 h-20 bg-black/40 backdrop-blur-md lg:hidden" />

          {/* Logo - Fixed top left */}
          <Link href="/" aria-label="Martini home" className="mw-link fixed start-6 top-6 z-50 md:start-8">
            <div className="flex h-9 w-28 items-center justify-center md:h-10 md:w-32">
              <MartiniWordmark className="h-9 w-auto md:h-10" />
            </div>
          </Link>

          {/* Navigation */}
          <MarketingNav />

          {/* Main Content */}
          <main className="flex flex-1 flex-col">{children}</main>

          {/* Footer */}
          <Footer />

          <MarketingTracker />
        </div>
      </LocaleAccessGate>
    </Providers>
  )
}
